import React from "react";
import { Dropdown } from "../../common/components/dropdownSelect";
import { formGroup } from "../../common/components/formGroup";

const DropdownList = Dropdown<number>();
interface Props {
    value: number,
    onChange: (value: number) => void
    error?: string;
    label?: string;
}

export function GetVatDescription(percentage: number) {
    return `${percentage * 100}%`
}

class __VatPercentageSelector extends React.PureComponent<Props>{
    render() {
        const { onChange, value, error, label } = this.props;
        const data = [0.22, 0.21, 0.20, 0.10, 0.5, 0.4, 0]
        return <DropdownList
            label={label}
            data={data}
            textField={x => GetVatDescription(x)}
            onSelect={onChange}
            value={value}
            error={error}
        />;
    }
}
export const VatPercentageSelector = formGroup(__VatPercentageSelector);
